<template>
  <div class="products">
    <div class="header-switch">
      <p :class="{ active: state == null }">
        <span @click="stateChangeAction(null)">{{ $t("cOrder.tab1") }}</span>
      </p>
      <p :class="{ active: state == 10 }">
        <el-badge
          :value="OrderCount.PaymentCount ? OrderCount.PaymentCount : null"
          class="item"
        >
          <span @click="stateChangeAction(10)">{{ $t("cOrder.tab2") }}</span>
        </el-badge>
      </p>
      <p :class="{ active: state == 20 }">
        <el-badge
          :value="OrderCount.DeliveryCount ? OrderCount.DeliveryCount : null"
          class="item"
        >
          <span @click="stateChangeAction(20)">{{ $t("cOrder.tab3") }}</span>
        </el-badge>
      </p>
      <p :class="{ active: state == 30 }">
        <el-badge
          :value="OrderCount.ReceivingCount ? OrderCount.ReceivingCount : null"
          class="item"
        >
          <span @click="stateChangeAction(30)">{{ $t("cOrder.tab4") }}</span>
        </el-badge>
      </p>
      <p :class="{ active: state == 1 }">
        <span @click="stateChangeAction(1)">{{ $t("cOrder.tab5") }}</span>
      </p>
    </div>
    <div class="page-action-box">
      <div class="pages">
        <p style="margin-left:10px;">
          {{
            $t("cOrder.totalOrder", {
              number: count
            })
          }}
        </p>
      </div>
    </div>
    <el-table :data="tableData" ref="table">
      <el-table-column :label="$t('cOrder.col1')" width="500">
        <template slot-scope="scope">
          <div style="cursor:pointer;" v-for="(item, index) in scope.row.OrderList" :key="index" @click="toDetail(item.OrderProducts.BProductNumber,item.OrderProducts.ShopId)">
            <el-image
              :src="imgUrlFilter(item.OrderProducts.ProductPhoto)"
              fit="cover"
              class="image"
            ></el-image>
            <span class="row-product-name">
              <div class="content">
                <p class="title">
                  {{ item.OrderProducts.ProductName }}
                </p>
                <p class="model">
                  {{ item.OrderProducts.ProductModelStr }}
                </p>
                <p class="count">x {{ item.OrderProducts.Number }}</p>
              </div>
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('cOrder.col3')">
        <template slot-scope="scope">
          <div class="row-product-order-number">
            {{ scope.row.AllOrderNumber }}
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('cOrder.col11')">
        <template slot-scope="scope">
          <p class="row-product-price">
            $ {{ scope.row.PayAllPrice | formatPrice }}
          </p>
          <p class="row-product-freight">
            {{ $t("cOrder.freight") }} $ {{ scope.row.AllFreight }}
          </p>
        </template>
      </el-table-column>
      <el-table-column :label="$t('cOrder.col5')">
        <template slot-scope="scope">
          {{ scope.row.StateStr }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('cOrder.col6')" width="200">
        <template slot-scope="scope">
          <div class="row-product-create-time">
            <p class="date">{{ scope.row.CreateTime }}</p>
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('cOrder.col7')" width="300">
        <template slot-scope="scope">
          <el-button-group>
            <el-button
              type="primary"
              size="mini"
              @click="getProductInfo(scope.row.AllOrderNumber)"
            >
              {{ $t("cOrder.payDetail") }}
            </el-button>
            <el-button
              type="danger"
              size="mini"
              v-if="scope.row.State == 10"
              @click="actionDelete(scope.row.AllOrderNumber)"
              >{{ $t("cOrder.cancelOrder") }}</el-button
            >
            <el-button
              type="danger"
              size="mini"
              v-if="scope.row.State == 30"
              @click="actionConfirm(scope.row.AllOrderNumber)"
              >{{ $t("cOrder.confirmOrder") }}</el-button
            >
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      class="pagination"
      :current-page="page"
      :page-sizes="[1, 5, 10, 15, 20, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="count"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "cOrders",
  data() {
    return {
      payVisible: false,
      AllOrderNumber: "",
      ChannelDealerId: "",
      PaymentLink: "",
      OrderCount: {},
      state: this.$route.query.state ? this.$route.query.state : null,
      page: 1,
      pageSize: 20,
      count: 0,
      lastPage: 0,
      tableData: [],
    };
  },
  watch: {
    $route(to, from) {
      this.request(to.query.state, this.page);
    }
  },
  mounted() {
    this.request(this.state, this.page);
    this.getCUser().then(res => {
      var data = res.data;
      this.OrderCount = data.OrderCount;
    });
  },
  methods: {
    ...mapActions(["getCUser"]),
    actionConfirm(orderNumber) {
      let param = {
        OrderNumber: orderNumber
      };
      this.$api.cOrder
        .confirmReceipt(param)
        .then(() => {
          this.request(this.state, this.page);
          this.getCUser().then(res => {
            var data = res.data;
            this.OrderCount = data.OrderCount;
          });
          this.$message.success(this.$t("B2C.success"));
        })
        .catch(err => {
          this.$message.error(err.message);
        });
    },
    actionDelete(orderNumber) {
      let param = {
        OrderNumber: orderNumber
      };
      this.$api.cOrder
        .cancelOrder(param)
        .then(() => {
          this.request(this.state, this.page);
          this.getCUser().then(res => {
            var data = res.data;
            this.OrderCount = data.OrderCount;
          });
          this.$message.success(this.$t("B2C.success"));
        })
        .catch(err => {
          this.$message.error(err.message);
        });
    },
    request(state, page) {
      const param = {
        PageIndex: page,
        PageSize: this.pageSize
      };
      if (state !== null) {
        param.ScreenValues = state;
      }
      this.$api.cOrder
        .loadOrderByPage(param)
        .then(res => {
          this.state = state;
          this.page = res.meta.page;
          this.count = res.meta.total;
          this.lastPage = res.meta.lastPage;
          this.tableData = res.data || [];
        })
        .catch(err => {
          this.$message.error(err.message);
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.request(this.state, this.page);
    },
    handleCurrentChange(val) {
      this.page = val;
      this.request(this.state, this.page);
    },
    stateChangeAction(state) {
      if (this.state === state) return;
      this.request(state, 1);
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value.split("|")[0]);
    },
    toDetail(productNumber, shopId) {
      this.$router.push({
        path: "/details",
        query: { ProductNumber: productNumber, ShopId: shopId }
      });
    },
    getProductInfo(orderNumber) {
      this.$router.push({
        path: "cOrderInfo",
        query: { orderNumber: orderNumber }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-collapse {
  .el-collapse-item__wrap {
    transition: none !important;
  }
}
.products {
  .header-switch {
    ::v-deep .el-badge__content {
      height: 20px;
      width: 20px;
      padding: 0px;
    }
  }
  .image {
    width: 66px;
    height: 66px;
    flex-shrink: 0;
    margin-left: 8px;
    margin-bottom: 10px;
  }
  .row-product-name {
    margin-left:10px;
    display: inline-block;
    width:70%;
    .content {
      font-size: 12px;
      flex: 1;
      position: relative;
      p {
        margin: 0;
      }
      .title {
        color: #333;
      }
      .labelimg {
        position: absolute;
        top: 0;
        left: 8rem;
      }
      .id {
        margin-top: 5px;
        color: #999;
      }
      .model {
        margin-top: 5px;
        color: #999;
      }
      .count {
        margin-top: 5px;
        color: #333;
        text-align: right;
        display: block;
      }
    }
  }
  .row-product-order-number {
    font-size: 14px;
    color:#25b9ff;
  }
  .row-product-price {
    margin: 0;
    font-size: 14px;
    color: #ff5852;
  }
  .row-product-freight {
    margin: 0;
    font-size: 12px;
    color: #999;
  }
  .row-product-sales {
    @extend .row-product-price;
    color: #333;
  }

  .row-product-create-time {
    font-size: 14px;
    p {
      margin: 0;
    }

    .date {
      color: #999;
    }

    .state {
      margin-top: 2px;
      color: #22b196;
    }
  }
  .row-product-action p {
    font-size: 12px;
    color: #25b9ff;
    margin: 0;
    cursor: pointer;
    // text-align: center;
  }

  ::v-deep .column-action {
    vertical-align: top;
  }
  .el-pagination {
    margin-top: 2%;
    margin-bottom: 2%;
    text-align: right;
  }
}
</style>
